export default class Ptc {
  constructor() {
    this.ticker = true;
    this.company_name = true;
    this.address = true;
    this.city = true;
    this.state = true;
    this.zip = true;
  }

  loadData(payload) {
    if (payload.Public_Company_Director_Info) {
      this.ticker = payload.Public_Company_Director_Info.Ticker;
      this.company_name = payload.Public_Company_Director_Info.Company_Name;
      this.address = payload.Public_Company_Director_Info.Address_1;
      this.city = payload.Public_Company_Director_Info.City;
      this.state = payload.Public_Company_Director_Info.State;
      this.zip = payload.Public_Company_Director_Info.Zip;
    }
  }
}
